<template>
  <div>
    <p>This permit relates to entry into any enclosed space and should be completed by the master or responsible person</p>

    <!--    기본정보-->
    <field-select-module
      class="mt-28px"
      title="Basic Information"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      field-name="Company"
      :typeslabel="fieldTypesLabel"
    />

    <!-- GENERAL -->
    <div>
      <h5 class="my-4"><i class="dot"></i> GENERAL</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div class="container-title">Location/name of enclosed space</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div class="writeGridLineItem">
          <div class="container-title">Reason for entry</div>
          <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputA_2 }}</p>
          <ml-textarea v-else :readonly="board.readonly" v-model="form.inputA_2" rows="5" />
        </div>
      </div>
    </div>

    <div>
      <h5 class="my-4">- This permit is valid</h5>
      <div class="writeGridContainer">
        <div>
          <div>From</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>date</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>
        <div>
          <div>hrs</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <time-selector v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
        <div>
          <div>To</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
        <div>
          <div>date</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_5 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputB_5" />
        </div>
        <div>
          <div>hrs</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_6 }}</p>
          <time-selector v-else :readonly="board.readonly" v-model="form.inputB_6" />
        </div>
      </div>
    </div>
    <p>The validity of an entry permit should not exceed 8 hours. (See note 1)</p>

    <!-- section 1 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> SECTION 1 – PRE-ENTRY PREPARATION
        <span class="mx-1 container-subtitle">(To be checked by the master or nominated responsible person)</span>
      </h5>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.section1">
          <template v-if="item.isCustom">
            <td colspan="3" class="content">
              <div class="content-title">{{ item.text }}</div>
              <div class="py-2 px-8 block">

                <div class="flex items-center py-1">
                  <span style="width: 120px;">Time: </span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.time }}</p>
                  <time-selector v-else="isPrint" v-model="item.time" style="width: 200px;" />

                  <span class="ml-8 mr-4">By: </span>
                  <p v-if="isPrint" class="print-input flex-1">{{ item.by }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.by" />
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">oxygen</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.oxygen }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.oxygen" style="width: 200px;"/>
                  <span class="mx-2">% vol (21%)**</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">hydrocarbon</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.hydrocarbon }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.hydrocarbon" style="width: 200px;"/>
                  <span class="mx-2">% LFL (less than 1%)</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">toxic gases</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.toxic_gases }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.toxic_gases" style="width: 200px;"/>
                  <span class="mx-2">ppm (less than 50% Occupational Exposure Limits</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">H2S</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.h2s }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.h2s" style="width: 200px;"/>
                  <span class="mx-2">PPM ( 1 PPM )</span>
                </div>

                <div class="flex items-center py-1">
                  <span style="width: 120px;">CO</span>
                  <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.co }}</p>
                  <ml-input v-else :readonly="board.readonly" v-model="item.co" style="width: 200px;"/>
                  <span class="mx-2">PPM ( 25 PPM )</span>
                </div>

                <p class="m-2 text-center">&lt;OEL> of the specific gas)     (See note 3)</p>

                <table>
                  <colgroup>
                    <col />
                    <col />
                  </colgroup>
                  <tr>
                    <td>
                      <div class="py-2 px-4">
                        <div class="flex items-center py-1">
                          <span style="width: 120px;">Previous Cargo :</span>
                          <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.previous_cargo }}</p>
                          <ml-input v-else :readonly="board.readonly" v-model="item.previous_cargo" style="width: 200px;"/>
                        </div>
                        <div class="flex items-center py-1">
                          <span style="width: 120px;">Used toxic tube :</span>
                          <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.used_toxic_tube }}</p>
                          <ml-input v-else :readonly="board.readonly" v-model="item.used_toxic_tube" style="width: 200px;"/>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="py-2 px-4">
                        <div class="flex items-center py-1">
                          <span style="width: 120px;">Toxic gas OEL :</span>
                          <p v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.toxic_gas }}</p>
                          <ml-input v-else :readonly="board.readonly" v-model="item.toxic_gas" style="width: 200px;"/>
                          <span class="mx-2">ppm or</span>
                          <PrintCheckbox v-if="isPrint" label="N/A" :value="item.toxic_gas_na" style="width: fit-content" class="mx-auto" />
                          <vs-checkbox v-else v-model="item.toxic_gas_na">N/A</vs-checkbox>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div class="py-2 px-4">
                        <p>Toxic gas is to be recorded actual reading in PPM if checked, if not applicable – to be recorded as ‘N/A’.</p>
                        <p>(Checks for specific toxic gas such as <span style="color: #FF0000;">Benzene, Hydrogen Sulphide and Carbon Monoxide</span>, should be undertaken according to the previous cargo carried in the space)</p>
                        <p style="display: inline; background-color: yellow; text-decoration: underline;">BWTS having electrolysis system could generate chlorine gas in ballast tanks therefore chlorine concentration should be checked before entering ballast tanks that have been treated</p>
                      </div>
                    </td>
                  </tr>
                </table>

              </div>
            </td>
          </template>
          <template v-else>
            <td class="content">
              <div class="content-title">{{ item.text }}</div>
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
        </tr>
        </tbody>
      </table>
      <p class="mt-3">* It should be noted that this is a generic entry permit that may be used for all enclosed spaces on board all ships.</p>
      <p>** Note that National requirements may determine the safe atmosphere range.</p>
    </div>

    <!-- section 2 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> SECTION 2 – PRE-ENTRY CHECKS
        <span class="mx-1 container-subtitle">(To be checked by each person entering the space)</span>
      </h5>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.section2">
          <template v-if="item.isCustom">
            <td colspan="3" class="content">
              <div class="content-title">
                I have agreed upon a reporting interval of
                <p v-if="isPrint" class="print-input flex-1" style="width: 80px;">{{ item.text }}</p>
                <ml-input v-else :readonly="board.readonly" v-model="item.text" style="width: 80px;"/>
                minutes
              </div>
            </td>
          </template>
          <template v-else>
            <td class="content">
              <div class="content-title">{{ item.text }}</div>
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- section 3 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> SECTION 3 – BREATHING APPARATUS AND OTHER EQUIPMENT
        <span class="mx-1 container-subtitle">(To be checked jointly by the master or nominated responsible person and the person who is to enter the space)</span>
      </h5>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.section3">
          <template>
            <td class="content">
              <div class="content-title">{{ item.text }}</div>
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 결재란 1 -->
    <div class="mt-28px">
      <h5 class="mb-4">Signed upon completion of sections 1, 2 and 3 by:</h5>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Master</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign1.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign1.date }}</span>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Attendant</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign2.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign2.date }}</span>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Person entering the space</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign3.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign3.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign3.date }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- section 4 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> SECTION 4 – PERSONNEL ENTRY
        <span class="mx-1 container-subtitle">(To be completed by the responsible person supervising entry)</span>
      </h5>
      <div class="writeGridContainer">
        <div>
          <div>Names</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_1" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>Time in</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_2 }}</p>
          <time-selector v-else :readonly="board.readonly" v-model="form.inputC_2" />
        </div>
        <div>
          <div>Time out</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_3 }}</p>
          <time-selector v-else :readonly="board.readonly" v-model="form.inputC_3" />
        </div>
      </div>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.section4">
          <template v-if="item.isCustom">
            <td colspan="3" class="content">
              <div class="content-title">This local atmosphere is safe for work</div>
              <div class="my-1">
                O2
                <span v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.o2 }}</span>
                <ml-input v-else :readonly="board.readonly" v-model="item.o2" style="width: 200px;"/>
                % Vol,

                <span class="mx-3">HC</span>
                <span v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.hc }}</span>
                <ml-input v-else :readonly="board.readonly" v-model="item.hc" style="width: 200px;"/>
                LEL,

                <span class="mx-3">H2S</span>
                <span v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.h2s }}</span>
                <ml-input v-else :readonly="board.readonly" v-model="item.h2s" style="width: 200px;"/>
                PPM,
                <span class="mx-3">CO</span>
                <span v-if="isPrint" class="print-input flex-1" style="width: 200px;">{{ item.co }}</span>
                <ml-input v-else :readonly="board.readonly" v-model="item.co" style="width: 200px;"/>
                PPM,
              </div>
              <p>* record worst figure among the measured value. </p>
            </td>
          </template>
          <template v-else>
            <td class="content">
              <div class="content-title">{{ item.text }}</div>
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'Yes'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'Yes'"
                           @change="item.isChecked === 'Yes' ? item.isChecked = '' : item.isChecked = 'Yes'" class="i-check justify-center" />
            </td>
            <td class="content">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === 'No'" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :checked="item.isChecked === 'No'"
                           @change="item.isChecked === 'No' ? item.isChecked = '' : item.isChecked = 'No'" class="i-check justify-center" />
            </td>
          </template>
        </tr>
        </tbody>
      </table>

      <table class="mt-28px">
        <thead>
        <tr>
          <th>THIS PERMIT IS RENDERED   INVALID SHOULD VENTILATION OF THE SPACE STOP<br/>
            OR IF ANY OF THE CONDITIONS NOTED IN THE CHECKLIST CHANGE</th>
        </tr>
        </thead>
      </table>
    </div>

    <!-- section 5 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> SECTION 5 – COMPLETION OF JOB
        <span class="mx-1 container-subtitle">(To be completed by the responsible person supervising entry)</span>
      </h5>
      <table>
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
        </colgroup>
        <thead>
        <tr>
          <th>Safety Measures Requirements</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in form.section5">
          <template>
            <td class="content">
              <div class="content-title">{{ item.text }}</div>
            </td>
            <td class="px-1">
              <p v-if="isPrint" class="print-input flex-1">{{ item.date }}</p>
              <date-selector v-else :readonly="board.readonly" v-model="item.date" />
            </td>
            <td class="px-1">
              <p v-if="isPrint" class="print-input flex-1">{{ item.time }}</p>
              <time-selector v-else :readonly="board.readonly" v-model="item.time" />
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 결재란 2 -->
    <div class="mt-28px">
      <h5 class="mb-4">Signed upon completion of sections 4 and 5 by:</h5>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>Responsible person supervising entry</div>
          <ml-input v-if="!isPrint" v-model="form.sign4.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign4.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">sign</div>
          <sign-field v-if="!isPrint && !board.readonly" lang="en" v-model="form.sign4.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign4.sign" :src="form.sign4.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
        <div>
          <div>Date/Time</div>
          <div>
            <ml-input v-if="!isPrint" class="w-full" v-model="form.sign4.date" :readonly="true" />
            <span v-else class="print-input w-full">{{ form.sign4.date }}</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h5 class="my-4"><i class="dot"></i> Notes</h5>
      <div>
        <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputD_1 }}</p>
        <ml-textarea v-else :readonly="true" v-model="form.inputD_1" rows="10" />
      </div>
    </div>

    <!-- Appendix 1 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> Appendix 1 : ATMOSPHERE MONITORING RECORD DURING WORK</h5>
      <div class="flex justify-between">
        <div class="mx-1 container-subtitle">
          <p>작업 중 가스 점검 (밀폐구역에서 30분이상 장기작업시, 밀폐구역의 가스농도(상/중/하) 매 30분마다 측정할 것)</p>
          <p>In case of long work more than 30 minutes in the enclosed space every space is to be checked at least once in 30 minutes interval by the responsible officer and recorded in below</p>
        </div>
        <div>
          <vs-button class="mr-4" color="secondary" @click="handleAddRow">Add item</vs-button>
          <vs-button color="secondary" type="border" @click="handleRemoveRow">Delete item</vs-button>
        </div>
      </div>

      <table class="mt-2">
        <colgroup>
          <col width="120" />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th class="p-1">Tank</th>
          <th class="p-1">Upper/Middle/Lower & Time</th>
          <th v-for="n in 5" :key="n" class="p-1">
            <p v-if="isPrint" class="print-input flex-1">{{ form.appendix1['time' + n] }}</p>
            <time-selector v-else :readonly="board.readonly" v-model="form.appendix1['time' + n]" class="w-full"/>
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-for="item in form.appendix1.list">
          <tr v-for="(data, dataIndex) in item.subList">
            <td rowspan="6" v-if="dataIndex === 0">
              <ml-input v-if="!isPrint" v-model="item.tank" :readonly="board.readonly" class="w-full px-1"/>
              <span v-else class="print-input px-1">{{ item.tank }}</span>
            </td>
            <td class="text-center">
              <span>{{ data.title }}</span>
            </td>
            <td v-for="n in 5" :key="n" class="p-1">
              <p v-if="isPrint" class="print-input flex-1">{{ data['input' + n] }}</p>
              <ml-input v-else :readonly="board.readonly" v-model="data['input' + n]" class="w-full"
                        :placeholder="dataIndex === item.subList.length - 1 ? '' : 'Upper/Middle/Lower'"/>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" title="Attachments" lang="en" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import SignField from "@/components/SignField.vue";
import Pagination from "@/components/Pagination.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    PrintCheckbox,
    TimeSelector,
    Pagination,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputD_1: "1 The permit should contain a clear indication as to its maximum period of validity.\n" +
          "\n" +
          "2 In order to obtain a representative cross-section of the space's atmosphere,\n" +
          "samples should be taken from several levels and through as many\n" +
          "openings as possible. Ventilation should be stopped for about 10 minutes\n" +
          "before the pre-entry atmosphere tests are taken.\n" +
          "\n" +
          "3 Tests for specific toxic contaminants, such as benzene or hydrogen sulphide, \n" +
          "should be undertaken depending on the nature of the previous contents of the space.\n",


        section1: [
          { isCustom: false, text: "Has the responsible officer carried out a risk assessment?", isChecked: "" },
          { isCustom: false, text: "Has the space been thoroughly ventilated by mechanical means?", isChecked: "" },
          { isCustom: false, text: "Has the space been segregated by blanking off or isolating all connecting pipelines or valves and electrical power/equipment? ", isChecked: "" },
          { isCustom: false, text: "Has the space been cleaned where necessary?", isChecked: "" },
          { isCustom: false, text: "Has the space been tested and found safe for entry? (See note 2)", isChecked: "" },
          {
            isCustom: true,
            text: "Pre-entry atmosphere test readings:",
            time: "",
            by: "",
            oxygen: "",
            hydrocarbon: "",
            toxic_gases : "",
            h2s: "",
            co: "",
            previous_cargo: "",
            used_toxic_tube: "",
            toxic_gas: "",
            toxic_gas_na: "",
          },
          { isCustom: false, text: "Have arrangements been made for frequent atmosphere checks to be made while the space is occupied and after work breaks?", isChecked: "" },
          { isCustom: false, text: "Have arrangements been made for the space to be continuously ventilated throughout the period of occupation and during work breaks?", isChecked: "" },
          { isCustom: false, text: "Are access and illumination adequate?", isChecked: "" },
          { isCustom: false, text: "Is rescue and resuscitation equipment available for immediate use by the entrance to the space?", isChecked: "" },
          { isCustom: false, text: "Has an attendant been designated to be in constant attendance at the entrance to the space?", isChecked: "" },
          { isCustom: false, text: "Has the officer of the watch (bridge, engine-room, cargo control room) been advised of the planned entry?", isChecked: "" },
          { isCustom: false, text: "Has a system of communication between all parties been tested and emergency signals agreed?", isChecked: "" },
          { isCustom: false, text: "Are emergency and evacuation procedures established and understood by all personnel involved with the enclosed space entry?", isChecked: "" },
          { isCustom: false, text: "Is all equipment used in good working condition and inspected prior to entry?", isChecked: "" },
          { isCustom: false, text: "Are personnel properly clothed and equipped?", isChecked: "" },
        ],
        section2: [
          { isCustom: false, text: "I have received instructions or permission from the master or nominated responsible person to enter the enclosed space                  ", isChecked: "" },
          { isCustom: false, text: "Section 1 of this permit has been satisfactorily completed by the master or nominated responsible person                                 \n", isChecked: "" },
          { isCustom: false, text: "I have agreed and understand the communication procedures               ", isChecked: "" },
          { isCustom: true, text: "", isChecked: "" },
          { isCustom: false, text: "Emergency and evacuation procedures have been agreed and are understood", isChecked: "" },
          { isCustom: false, text: "I am aware that the space must be vacated immediately in the event of ventilation failure or if atmosphere tests show a change from agreed safe criteria", isChecked: "" },
        ],
        section3: [
          { isCustom: false, text: "Those entering the space are familiar with any breathing apparatus to be used", isChecked: "" },
          { isCustom: false, text: "The breathing apparatus has been tested as follows: \n" +
              "- gauge and capacity of air supply\n" +
              "- low pressure audible alarm if fitted\n" +
              "- face mask – under positive pressure and not leaking", isChecked: "" },
          { isCustom: false, text: "The means of communication has been tested and emergency signals agreed", isChecked: "" },
          { isCustom: false, text: "All personnel entering the space have been provided with harnesses and, where practicable, lifelines", isChecked: "" },
          { isCustom: false, text: "Initial entry persons have been provided with EEBD, personal gas detector.\n", isChecked: "" },
        ],
        section4: [
          { isCustom: false, text: "Initial entry persons have checked the atmosphere of the work locations and areas inaccessible for testing from the deck before work", isChecked: "" },
          { isCustom: true,
            o2: "",
            hc: "",
            h2s: "",
            co: "",
            isChecked: ""
          },
        ],
        section5: [
          { text: "Job completed", date: "", time: "", },
          { text: "Space secured against entry", date: "", time: "", },
          { text: "The officer of the watch has been duly informed", date: "", time: "", },
        ],
        appendix1: {
          time1: "", time2: "", time3: "", time4: "", time5: "",
          list: [
            {
              id: 1,
              tank: "",
              subList: [
                { title: "Oxygen % (VOL)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Hydrocarbon % (LEL)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Carbon monoxide (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Hydrogen sulfide (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Toxic Gas (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Used Toxic tube", input1: "", input2: "", input3: "", input4: "", input5: "" },
              ],
            },
            {
              id: 2,
              tank: "",
              subList: [
                { title: "Oxygen % (VOL)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Hydrocarbon % (LEL)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Carbon monoxide (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Hydrogen sulfide (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Toxic Gas (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
                { title: "Used Toxic tube", input1: "", input2: "", input3: "", input4: "", input5: "" },
              ],
            },
          ],
        },

        fileList: [],

        sign1: {
          name: "",
          sign: "",
          date: "",
        },
        sign2: {
          name: "",
          sign: "",
          date: "",
        },
        sign3: {
          name: "",
          sign: "",
          date: "",
        },
        sign4: {
          name: "",
          sign: "",
          date: "",
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.sign1': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign1.date = this.saveTime()
        } else {
          this.form.sign1.date = ""
        }
      },
    },
    'form.sign2': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign2.date = this.saveTime()
        } else {
          this.form.sign2.date = ""
        }
      },
    },
    'form.sign3': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign3.date = this.saveTime()
        } else {
          this.form.sign3.date = ""
        }
      },
    },
    'form.sign4': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.sign) {
          this.form.sign4.date = this.saveTime()
        } else {
          this.form.sign4.date = ""
        }
      },
    }
  },
  computed: {
    fieldTypesLabel() {
      return {
        writer_name: "Writer",
        date: "Date",
      };
    }
  },
  methods: {
    saveTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth() + 1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);
      let hours = ("0" + date.getHours()).slice(-2);
      let minutes = ("0" + date.getMinutes()).slice(-2);
      let seconds = ("0" + date.getSeconds()).slice(-2);

      let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      return formattedDate;
    },
    handleAddRow() {
      const data = {
        id: Date.now(),
        tank: "",
        subList: [
          { title: "Oxygen % (VOL)", input1: "", input2: "", input3: "", input4: "", input5: "" },
          { title: "Hydrocarbon % (LEL)", input1: "", input2: "", input3: "", input4: "", input5: "" },
          { title: "Carbon monoxide (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
          { title: "Hydrogen sulfide (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
          { title: "Toxic Gas (PPM)", input1: "", input2: "", input3: "", input4: "", input5: "" },
          { title: "Used Toxic tube", input1: "", input2: "", input3: "", input4: "", input5: "" },
        ],
      }
      this.form.appendix1.list.push(data)
    },
    handleRemoveRow() {
      this.form.appendix1.list.pop()
    }
  },
};
</script>
<style scoped lang="scss">
.container-title {
  line-height: normal;
  word-break: break-word;
}
.container-subtitle {
  font-weight: 400;
  font-size: 14px;
}
.i-check::v-deep .vs-checkbox {
  margin: 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  thead {
    th {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #3c3c3c;
      background: #f9f9f9;
      padding: 16px 0;
    }
  }

  tbody {
    .title-tr td {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
      padding: 14px;
    }
    .footer-tr td {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
    }
    .sub-title {
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
      padding: 14px 0;
    }

    .content {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      padding: 14px;

      & > div {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 8px;
      }

      &.empty-style {
        padding: 4px !important;
        & > div {
          display: block;
        }
      }

      &::v-deep {
        .vs-radio--label {
          line-height: 0;
        }
      }

      .content-title::before {
        content: '· ';
      }
    }
  }
}
</style>

